export default class MainNav {
  // html selector for the component
    static selectorString()
    {
        return '.js-main-nav';
    }

  // rootNode = html element with js-class
  // props = data attribute 'props' to pass down customization
    constructor(rootNode, props)
    {
        this.burgerIcon = rootNode.querySelector('.burger-icon');
        this.nav = rootNode.querySelector('.main-menu');

        this.burgerIcon.addEventListener('click', this.toggleNav.bind(this));

        this.submenuItems = [...rootNode.querySelectorAll('.with--drop')];
        this.submenuItems.forEach((item) => {
            item.querySelector('.level-1-link').addEventListener('click', this.level1Clicked.bind(this));
        });

        rootNode.querySelector('.search-wrap').addEventListener('click', this.preventEventPropagation.bind(this));
        document.body.addEventListener('click', this.hideSearchInput.bind(this));

        this.buildMobileNav();
    }

    toggleNav()
    {
        jQuery('.mobile-menu').show();
        setTimeout(() => {
            document.body.classList.toggle('menu-open');
            if (document.body.classList.contains('menu-open')) {
                this.burgerIcon.classList.add('open');
            } else {
                this.burgerIcon.classList.remove('open');
                jQuery('.mobile-menu').hide();
            }
        }, 100);
    }

    level1Clicked(event)
    {
        if (getComputedStyle(this.burgerIcon).display !== 'block') {
            return;
        }

        if (!event.currentTarget.classList.contains('clicked')) {
            event.preventDefault();

            this.submenuItems.forEach((item) => {
                item.querySelector('.level-1-link').classList.remove('clicked');
            });

            event.currentTarget.classList.add('clicked');
        }
    }

    preventEventPropagation(event)
    {
        event.stopPropagation();
    }

    hideSearchInput()
    {
        document.body.classList.remove('page-search-popup-opened');
    }

    buildMobileNav()
    {
        jQuery(document).ready(function () {

            var top = jQuery('#page-header').outerHeight();
            if (jQuery('.HighlightOffer').length > 0) {
                top += jQuery('.HighlightOffer').outerHeight();
            }

            jQuery('<div id="mobile-menu" class="mobile-menu" style="top:'+top+'px;"><ul class="navigation"></ul></div>').appendTo("body");
            var navigation = jQuery("#mobile-menu .navigation");
            var mainmenu = jQuery(".main-menu").clone();


            mainmenu.find('.level-1').each(function () {

                var _level1 = jQuery(this);
                var _level1Element = _level1.wrap('<div></div>').closest('div').html();
                var _level2Html = '';

                if (_level1.closest('li').find('.level-2').length > 0) {
                    _level2Html += '<ul>';
                    _level1.closest('li').find('.level-2').each(function () {
                        var _level2 = jQuery(this);
                        var _level2Element = _level2.wrap('<div></div>').closest('div').html();

                        var _level3Html = '';
                        if (_level2.closest('ul').find('.level-3').length > 0) {
                            _level3Html += '<ul>';
                            _level2.closest('ul').find('.level-3').each(function () {
                                var _level3 = jQuery(this);
                                var _level3Element = _level3.wrap('<div></div>').closest('div').html();
                                _level3Html += "<li class='has-no-sub'>"+_level3Element+"</li>";
                            });
                            _level3Html += '</ul>';
                        }

                        _level2Html += "<li class='"+((_level3Html !== "") ? 'has-sub' : 'has-no-sub')+"'>"+_level2Element+_level3Html+"</li>";
                    });
                    _level2Html += '</ul>';
                }

                navigation.append("<li class='"+ ((_level2Html !== "") ? 'has-sub' : 'has-no-sub') +"'>" + _level1Element + _level2Html + "</li>");
            });

            navigation.find('.has-sub > a, .has-sub > .void-link, .has-sub > .level-1-link').prepend('<span class="arrow"></span>');

            navigation.find('.arrow, .void-link, .level-1-link').click(function (e) {
                e.stopPropagation();
                jQuery(this).closest('li').toggleClass('active');
                jQuery(this).closest('li').find('>ul').slideToggle();
            });

        });
    }

}
